<template>
  <divcard titled>
    <div class="card-part pt-0">
      <div class="txt-head black--text mb-2">
        <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
      </div>

      <!-- 1 ขั้นตอนและขอบเขตการดำเนินโครงการ -->
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.principle ? true : false">
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            1. หลักการและเหตุผล
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm?.principle?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <!-- 2. วัตถุประสงค์ -->
    <div class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.objective ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            2. วัตถุประสงค์
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 4 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm?.objective?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. กลุ่มเป้าหมายในพื้นที่ (Demand side) -->
    <div class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('three')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            3. กลุ่มเป้าหมายในพื้นที่ (Demand Side)
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 5 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
              </div>
              <div class="pl-10" v-html="partTwoForm.demand?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 5 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
              </div>
              <div class="pl-10" v-html="partTwoForm.marketing?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 4. ขั้นตอนและขอบเขตการดำเนินโครงการ -->
    <div class="card-part">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.scope ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            4. ขั้นตอนและขอบเขตการดำเนินโครงการ
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 4 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm?.scope?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 5. ศักยภาพและความพร้อมในการดำเนินโครงการของอุทยานวิทยาศาสตร์ภูมิภาค -->
    <div class="card-part" v-if="!isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('SI_5')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            5. ศักยภาพและความพร้อมในการดำเนินโครงการของอุทยานวิทยาศาสตร์ภูมิภาค
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 5 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมของห้องปฏิบัติการ/อุปกรณ์ที่มีอยู่เดิมในการให้บริการภาคเอกชน
              </div>
              <div class="pl-10" v-html="partTwoForm.lab_ready?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 5 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แผนการเสริมศักยภาพอุปกรณ์และสิ่งอำนวยความสะดวก
              </div>
              <div class="pl-10" v-html="partTwoForm.tools_enhance?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 5 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความสะดวกและรวดเร็วในการให้บริการ รวมถึงมีความสะดวกในการเข้าถึงและเชื่อมโยงกับบริการของหน่วยงานอื่น (เชื่อมโยงกับกงสี)
              </div>
              <div class="pl-10" v-html="partTwoForm.convenient?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 5 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนวทางการพัฒนาบุคลากร และความรู้ความสามารถของบุคลากรผู้ให้บริการ
              </div>
              <div class="pl-10" v-html="partTwoForm.improve_officer?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 5 #line5 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ
              </div>
              <div class="pl-10" v-html="partTwoForm.reference?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 5. แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต -->
    <div class="card-part" v-else>
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.initiative_idea ? true : false">
            ></ValidatorIcon>

          <div class="font-type-bold black--text">
            5. แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.initiative_idea?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 6. ผลการดำเนินงานที่ผ่านมา -->
    <div class="card-part" v-if="!isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('SI_6')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            6. ผลการดำเนินงานที่ผ่านมา
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 6 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนวทางที่จะปรับปรุงและพัฒนาการให้บริการโดยประเมินจากการดำเนินงานที่ผ่านมา
              </div>
              <div class="pl-10" v-html="partTwoForm.past_improvement?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 6 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การบริหารจัดการในการพัฒนาศักยภาพและการให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม ในปีงบประมาณที่ผ่านมา
              </div>
              <div class="pl-10" v-html="partTwoForm.past_management?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
          <!-- Form 6 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ผลการดำเนินงานในการพัฒนาศักยภาพและการให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม
              </div>
              <div class="pl-10" v-html="partTwoForm.past_performance?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- 6. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย -->
    <div class="card-part" v-else>
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.initiative_idea ? true : false">
            ></ValidatorIcon>

          <div class="font-type-bold black--text">
            6. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.industrial_target?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 7. แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต -->
    <div class="card-part" v-if="!isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.initiative_idea ? true : false">
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            7. แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.initiative_idea?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 7. เป้าหมาย -->
    <div class="card-part" v-else>
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.target ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            7. เป้าหมาย
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 4 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm?.target?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 8. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย -->
    <div class="card-part" v-if="!isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.industrial_target ? true : false">
            ></ValidatorIcon>

          <div class="font-type-bold black--text">
            8. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.industrial_target?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TODO: 8. การดำเนินงานและผลการดำเนินงานแผนงานการพัฒนาบริการของอุทยานวิทยาศาสตร์ -->
    <div class="card-part" v-else>
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('Final_8')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            8. การดำเนินงานและผลการดำเนินงานแผนงานการพัฒนาบริการของอุทยานวิทยาศาสตร์
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การพัฒนาศักยภาพและให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.pd_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.pd_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.pd_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.pd_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.pd_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.pd_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.pd_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.pd_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.pd_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.pd_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.pd_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.pd_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                บริการออกแบบนวัตกรรม
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.ds_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.ds_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.ds_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ds_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.ds_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.ds_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.ds_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.ds_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.ds_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ds_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.ds_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.ds_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การบริหารจัดการทรัพย์สินทางปัญญาแก่ภาคอุตสาหกรรม
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.ip_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.ip_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.ip_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ip_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.ip_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.ip_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.ip_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.ip_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.ip_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ip_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.ip_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.ip_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ฐานข้อมูลโครงสร้างพื้นฐานภาครัฐด้านวิทยาศาสตร์และเทคโนโลยี (Science and Technology Infrastructure Databank : STDB)
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.stdb_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.stdb_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.stdb_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.stdb_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.stdb_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.stdb_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.stdb_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.stdb_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.stdb_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.stdb_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.stdb_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.stdb_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.ref_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.ref_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.ref_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ref_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.ref_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.ref_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.ref_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.ref_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.ref_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ref_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.ref_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.ref_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div> 

    <!-- 9. เป้าหมาย -->
    <div class="card-part" v-if="!isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoForm?.target ? true : false"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            9. เป้าหมาย
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 4 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm?.target?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TODO: 10. การดำเนินงานและผลการดำเนินงานแผนงานการพัฒนาบริการของอุทยานวิทยาศาสตร์ -->
    <div class="card-part" v-if="!isFinal">
      <div>
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partTwoValidate('SI_10')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            10. การดำเนินงานและผลการดำเนินงานแผนงานการพัฒนาบริการของอุทยานวิทยาศาสตร์
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                10.1 การพัฒนาศักยภาพและให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.pd_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.pd_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.pd_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.pd_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.pd_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.pd_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.pd_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.pd_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.pd_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.pd_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.pd_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.pd_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
               10.2 บริการออกแบบนวัตกรรม
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.ds_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.ds_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.ds_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ds_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.ds_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.ds_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.ds_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.ds_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.ds_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ds_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.ds_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.ds_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
               10.3 การบริหารจัดการทรัพย์สินทางปัญญาแก่ภาคอุตสาหกรรม
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.ip_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.ip_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.ip_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ip_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.ip_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.ip_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.ip_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.ip_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.ip_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ip_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.ip_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.ip_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                10.4 National Science and Technology Information System (NSTIS)
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.stdb_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.stdb_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.stdb_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.stdb_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.stdb_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.stdb_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.stdb_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.stdb_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.stdb_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.stdb_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.stdb_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.stdb_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
           <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                10.5 การพัฒนาศักยภาพและให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.ic_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.ic_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.ic_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ic_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.ic_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.ic_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.ic_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.ic_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.ic_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ic_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.ic_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.ic_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                10.6 ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ
              </div>
              <div class="pl-5">
                <ul class="pl-16">
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ภาพรวมของกิจกรรม
                      </div>
                      <div v-html="partTwoForm.ref_overview?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                      </div>
                      <div v-html="partTwoForm.ref_needs?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                      </div>
                      <div v-html="partTwoForm.ref_marketing?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ศักยภาพและความพร้อมในการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ref_readiness?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                      </div>
                      <div v-html="partTwoForm.ref_organization?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                      </div>
                      <div v-html="partTwoForm.ref_facilities?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        กระบวนการให้บริการลูกค้า
                      </div>
                      <div v-html="partTwoForm.ref_service_process?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                      </div>
                      <div v-html="partTwoForm.ref_connection?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                      </div>
                      <div v-html="partTwoForm.ref_experts?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลการดำเนินงาน
                      </div>
                      <div v-html="partTwoForm.ref_performance?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลผลิตและตัวชี้วัดความสำเร็จ
                      </div>
                      <div v-html="partTwoForm.ref_kpi?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="black--text mb-1">
                        ผลลัพธ์และผลกระทบ
                      </div>
                      <div v-html="partTwoForm.ref_results?.replace(/\n/g, '<br>')"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </divcard>
</template>

<script>
import TextField from "../../../../components/input/TextField"
import SwitchInset from ".././../../../components/input/SwitchInset"
import AutoBox from "../../../../components/input/AutoBox"
import {eventBus, formatNumber, validateEmail} from "@/plugins/global-funcs"
import { mapState } from "vuex"
import OOILineField from '../../../../components/OOILineField'
import ValidatorIcon from "../../../../components/ValidatorIcon"
import Wysiwyg from "@/components/input/Wysiwyg.vue";

export default {
  name: "CFormSummary_SP",
  components: {
    Wysiwyg,
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon
  },
  props: {
    data: {
      default: () => ({})
    },
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      formatNumber,
      partTwoForm: {},
      ableToSubmit: true,
      dataReady: false
    }
  },
  computed: {
    ...mapState({
      SummaryData: state => state.CForm.SummaryData
    }),
    isFinal () {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  async created () {
    eventBus.$emit('cFormSummary')
    await new Promise((res, rej) => setTimeout(res, 100))

    this.partTwoForm = this.data;
    this.dataReady = true
  },
  methods: {
    allowFormAbleSubmit(isCorrect) {
      if (!isCorrect && this.dataReady) {
        this.ableToSubmit = false;
      }
      eventBus.$emit("CFormPlanAbleToSubmit", this.ableToSubmit);
    },
    partTwoValidate (section) {
      let isCorrect = true
      switch (section) {
        
        case 'three':
          
          if (!this.partTwoForm.demand ||
              !this.partTwoForm.marketing)
          { isCorrect = false }
          
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
          
        case 'SI_5':
          
          if (!this.partTwoForm.lab_ready ||
              !this.partTwoForm.tools_enhance ||
              !this.partTwoForm.convenient ||
              !this.partTwoForm.improve_officer ||
              !this.partTwoForm.reference)
          { isCorrect = false }
          
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
          
        case 'SI_6':
            
            if (!this.partTwoForm.past_improvement ||
                !this.partTwoForm.past_management ||
                !this.partTwoForm.past_performance)
            { isCorrect = false }
            
            this.allowFormAbleSubmit(isCorrect);
            return isCorrect;
        
        case 'Final_8':
          
          if (!this.partTwoForm.pd_overview ||
              !this.partTwoForm.pd_needs ||
              !this.partTwoForm.pd_marketing ||
              !this.partTwoForm.pd_readiness ||
              !this.partTwoForm.pd_organization ||
              !this.partTwoForm.pd_service_process ||
              !this.partTwoForm.pd_connection ||
              !this.partTwoForm.pd_experts ||
              !this.partTwoForm.pd_performance ||
              !this.partTwoForm.pd_kpi ||
              !this.partTwoForm.pd_results ||
              
              !this.partTwoForm.ds_overview ||
              !this.partTwoForm.ds_needs ||
              !this.partTwoForm.ds_marketing ||
              !this.partTwoForm.ds_readiness ||
              !this.partTwoForm.ds_organization ||
              !this.partTwoForm.ds_service_process ||
              !this.partTwoForm.ds_connection ||
              !this.partTwoForm.ds_experts ||
              !this.partTwoForm.ds_performance ||
              !this.partTwoForm.ds_kpi ||
              !this.partTwoForm.ds_results ||

              !this.partTwoForm.ip_overview ||
              !this.partTwoForm.ip_needs ||
              !this.partTwoForm.ip_marketing ||
              !this.partTwoForm.ip_readiness ||
              !this.partTwoForm.ip_organization ||
              !this.partTwoForm.ip_service_process ||
              !this.partTwoForm.ip_connection ||
              !this.partTwoForm.ip_experts ||
              !this.partTwoForm.ip_performance ||
              !this.partTwoForm.ip_kpi ||
              !this.partTwoForm.ip_results ||

              !this.partTwoForm.stdb_overview ||
              !this.partTwoForm.stdb_needs ||
              !this.partTwoForm.stdb_marketing ||
              !this.partTwoForm.stdb_readiness ||
              !this.partTwoForm.stdb_organization ||
              !this.partTwoForm.stdb_service_process ||
              !this.partTwoForm.stdb_connection ||
              !this.partTwoForm.stdb_experts ||
              !this.partTwoForm.stdb_performance ||
              !this.partTwoForm.stdb_kpi ||
              !this.partTwoForm.stdb_results ||

              !this.partTwoForm.ref_overview ||
              !this.partTwoForm.ref_needs ||
              !this.partTwoForm.ref_marketing ||
              !this.partTwoForm.ref_readiness ||
              !this.partTwoForm.ref_organization ||
              !this.partTwoForm.ref_service_process ||
              !this.partTwoForm.ref_connection ||
              !this.partTwoForm.ref_experts ||
              !this.partTwoForm.ref_performance ||
              !this.partTwoForm.ref_kpi ||
              !this.partTwoForm.ref_results
            )
          { isCorrect = false }
          
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case 'SI_10':

          if (!this.partTwoForm.pd_overview ||
              !this.partTwoForm.pd_needs ||
              !this.partTwoForm.pd_marketing ||
              !this.partTwoForm.pd_readiness ||
              !this.partTwoForm.pd_organization ||
              !this.partTwoForm.pd_service_process ||
              !this.partTwoForm.pd_connection ||
              !this.partTwoForm.pd_experts ||
              !this.partTwoForm.pd_performance ||
              !this.partTwoForm.pd_kpi ||
              !this.partTwoForm.pd_results ||

              !this.partTwoForm.ds_overview ||
              !this.partTwoForm.ds_needs ||
              !this.partTwoForm.ds_marketing ||
              !this.partTwoForm.ds_readiness ||
              !this.partTwoForm.ds_organization ||
              !this.partTwoForm.ds_service_process ||
              !this.partTwoForm.ds_connection ||
              !this.partTwoForm.ds_experts ||
              !this.partTwoForm.ds_performance ||
              !this.partTwoForm.ds_kpi ||
              !this.partTwoForm.ds_results ||

              !this.partTwoForm.ip_overview ||
              !this.partTwoForm.ip_needs ||
              !this.partTwoForm.ip_marketing ||
              !this.partTwoForm.ip_readiness ||
              !this.partTwoForm.ip_organization ||
              !this.partTwoForm.ip_service_process ||
              !this.partTwoForm.ip_connection ||
              !this.partTwoForm.ip_experts ||
              !this.partTwoForm.ip_performance ||
              !this.partTwoForm.ip_kpi ||
              !this.partTwoForm.ip_results ||

              !this.partTwoForm.stdb_overview ||
              !this.partTwoForm.stdb_needs ||
              !this.partTwoForm.stdb_marketing ||
              !this.partTwoForm.stdb_readiness ||
              !this.partTwoForm.stdb_organization ||
              !this.partTwoForm.stdb_service_process ||
              !this.partTwoForm.stdb_connection ||
              !this.partTwoForm.stdb_experts ||
              !this.partTwoForm.stdb_performance ||
              !this.partTwoForm.stdb_kpi ||
              !this.partTwoForm.stdb_results ||

              !this.partTwoForm.ic_overview ||
              !this.partTwoForm.ic_needs ||
              !this.partTwoForm.ic_marketing ||
              !this.partTwoForm.ic_readiness ||
              !this.partTwoForm.ic_organization ||
              !this.partTwoForm.ic_service_process ||
              !this.partTwoForm.ic_connection ||
              !this.partTwoForm.ic_experts ||
              !this.partTwoForm.ic_performance ||
              !this.partTwoForm.ic_kpi ||
              !this.partTwoForm.ic_results ||

              !this.partTwoForm.ref_overview ||
              !this.partTwoForm.ref_needs ||
              !this.partTwoForm.ref_marketing ||
              !this.partTwoForm.ref_readiness ||
              !this.partTwoForm.ref_organization ||
              !this.partTwoForm.ref_service_process ||
              !this.partTwoForm.ref_connection ||
              !this.partTwoForm.ref_experts ||
              !this.partTwoForm.ref_performance ||
              !this.partTwoForm.ref_kpi ||
              !this.partTwoForm.ref_results
          )
          { isCorrect = false }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
  }
}
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #FFFFFF;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #FAFAFA;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #FFFFFF;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}


.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr));
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: 'Tahoma', sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
</style>